import { concat, concatMap, ignoreElements, of, ReplaySubject, tap, timer } from 'rxjs';

/**
 *
 * @param {number} [delay=0] Delay between emissions in milliseconds
 * @return {{subscribe(*): import('rxjs').Subscription, push(*): void}}
 * @constructor
 */
export function Queue(delay = 0) {
  let _queue = new ReplaySubject();
  let hasConsumer = false;
  const _buffer = new Set();

  return {
    push(item) {
      if (_buffer.size > 100) {
        _buffer.clear();
        console.warn('Queue buffer overflow');
      }
      _buffer.add(item);
      if (hasConsumer) {
        _queue.next(item);
      }
    },
    subscribe(observer) {
      if (hasConsumer) {
        console.warn('Queue already has consumer');
        return;
      }
      hasConsumer = true;
      _queue = new ReplaySubject();
      _buffer.forEach((item) => {
        _queue.next(item);
      });
      const producer = _queue.pipe(
        concatMap((item) => {
          return concat(of(item), timer(delay).pipe(ignoreElements()));
        }),
        tap((item) => {
          _buffer.delete(item);
          // console.debug('Remove consumed item from buffer', _buffer);
        }),
      );

      const subscription = producer.subscribe(observer);
      const unsubscribe = subscription.unsubscribe.bind(subscription);
      subscription.unsubscribe = () => {
        hasConsumer = false;
        unsubscribe();
      };
      return subscription;
    },
  };
}
